import * as React from "react"
import type { IconProps } from "../types"

const ChevronDownMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", strokeWidth = 2, size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          d="M8 10L12 14L16 10"
        />
      </svg>
    )
  }
)
ChevronDownMini.displayName = "ChevronDownMini"

export default ChevronDownMini